import React, { ReactNode } from 'react'
import styles from './styles.module.scss'

interface Props {
  caption: ReactNode
  imageId: string
  alt: string
}

export function EmbeddedImage({ caption, imageId, alt }: Props) {
  const imageSrcSet = require('images/les-verrieres/' +
    imageId +
    '.jpg?sizes=1800w+900w+640w+320w')
  return (
    <figure className={styles.embeddedImage}>
      <img
        srcSet={imageSrcSet.srcSet}
        src={imageSrcSet.sources['640w']}
        sizes='(min-width: 900px) 900px, 98vw'
        alt={alt}
      />
      <figcaption>{caption} Foto: Ephraim Bieri</figcaption>
    </figure>
  )
}
